module.exports = __webpack_public_path__ + "img/Whatsapp.30a049ab.svg";